import React from "react";

function OnGoing() {
    return (
        <div className="on-going-column">
            <h1 className="related-header">On going Event</h1>
            <div className="on-going-events">
                <img className="on-going-image" src="https://i.pinimg.com/564x/23/2f/3a/232f3a8cb43e1b5d615cccb6b64d008e.jpg" alt="On Going Event" />
                <img className="on-going-image" src="https://i.pinimg.com/564x/17/02/52/1702523f9bda00d43c6b73321908a521.jpg" alt="On Going Event" />
            </div>
        </div>
    );
}

export default OnGoing;
